import React from "react";
import { useTranslation } from "react-i18next";

const Card = ({
  image,
  title,
  svg,
  description = "Sample description text",
}) => {
  const { t } = useTranslation("home");
  return (
<div className="relative group w-full h-[297px] overflow-hidden rounded-xl shadow-lg mt-[63px]">
  {/* Base image with reduced opacity */}
  <img
    src={image}
    alt={title}
    className="w-full h-full object-cover opacity-40"
  />

  {/* Gradient overlay with bottom-to-top animation */}
  <div
  className="absolute inset-0 bg-black 
    opacity-0 
    group-hover:opacity-100 
    transition-opacity 
    duration-500 
    ease-in-out"
>
  {/* Ellipse from assets */}
  <img
    src="/assets/ellipse.svg"
    alt="ellipse effect"
    className="absolute bottom-[-100px] right-[-100px] w-[350px] h-[350px] opacity-100"
  />
</div>

  {/* SVG icon */}
  <div className="absolute top-7 left-7">
    <img src={svg} alt={title} className="h-8" />
  </div>

  {/* Content container */}
  <div className="absolute inset-0 flex flex-col justify-end">
    <div className="transform transition-transform duration-300 group-hover:-translate-y-16 delay-100 text-center">
      <span className="body-xl-2 text-color-2 block text-left ml-4"> {t(title)}</span>
      <p className="text-color-5 title-small-4 mt-2 text-left ml-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-200">
      {t(description)}
      </p>
    </div>
  </div>
</div>

  );
};

const ProximityDetectionSection = () => {
  const { t } = useTranslation("home");

  return (
    <div className="relative mx-auto px-[30px] max-w-[1220px] md:my-20  ">
      <h2 className="web-heading-section text-color-2 mb-2 ">
        
      {t("proximity_detection_collision_prevention")}

      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 md:gap-5">
        <Card
          image="/assets/card1.png"
          title="proximity_detection_collision_prevention"
          svg="/assets/shield.svg"
          description="underground_safety_description"
        />
        <Card
          image="/assets/card2.png"
          title="operations_optimization"
          svg="/assets/fork.svg"
          description="streamline_operations_description"
        />
        <Card
          image="/assets/card3.png"
          title="workforce_safety"
          svg="/assets/personshield.svg"
          description="employee_wellbeing_description"
        />
        <Card
          image="/assets/card4.png"
          title="training_development"
          svg="/assets/clock.svg"
          description="maximize_training_roi"
        />
      </div>
    </div>
  );
};

export default ProximityDetectionSection;
